<div class="section">
  <div class="container-max max-w-3xl prose">
    <h1 class="font-sans text-headline-lg mb-6">Términos y condiciones</h1>
    <p class="text-on-surface-variant mb-4">
      Al usar Chambia, tanto como candidato o como empresa, aceptas los presentes términos y condiciones de uso.
    </p>
    <h2 class="font-bold text-lg mt-8 mb-2">1. Uso de la plataforma</h2>
    <p class="text-on-surface-variant mb-4">
      Chambia conecta candidatos y empresas en LATAM mediante WhatsApp y matching por inteligencia artificial. El uso de la
      plataforma para candidatos es gratuito; las empresas contratan planes de suscripción y pagan un fee de éxito por
      contratación.
    </p>
    <h2 class="font-bold text-lg mt-8 mb-2">2. Cuentas y verificación</h2>
    <p class="text-on-surface-variant mb-4">
      Los candidatos se registran mediante verificación de número de WhatsApp vía código OTP. Las empresas deben completar
      un proceso de verificación antes de publicar vacantes.
    </p>
    <h2 class="font-bold text-lg mt-8 mb-2">3. Contenido de vacantes</h2>
    <p class="text-on-surface-variant mb-4">
      Las empresas son responsables de la veracidad de la información publicada en sus vacantes. Chambia se reserva el
      derecho de remover contenido que viole la ley o nuestras políticas.
    </p>
    <h2 class="font-bold text-lg mt-8 mb-2">4. Contacto</h2>
    <p class="text-on-surface-variant">
      Para dudas sobre estos términos, contáctanos a través de WhatsApp desde el botón flotante en el sitio.
    </p>
  </div>
</div>
